import styled, { css } from 'styled-components'

export const TasksTabsContainer = styled.div<{ noMargin?: boolean }>`
  margin: ${(props) => (props.noMargin ? '0' : '0 1rem')};
  max-width: 50%;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 999999;
  margin-right: 1rem;
  -ms-overflow-style: none;
  scrollbar-width: none;
  position: relative;
  ::-webkit-scrollbar {
    display: none; /* Safari and Chrome */
  }
  @media (max-width: 1370px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  }
`

export const TaskTabsArrow = styled.div`
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  z-index: 9999999999999900;
  svg {
    transform: rotate(-90deg) scale(2);
  }
`

interface ITaskTabsProps {
  active: boolean
  adaptWidth?: boolean
}

export const TasksTabs = styled.div<ITaskTabsProps>`
  background: ${(props) => props.theme.inputActiveBackground} !important;
  min-width: ${(props) => (props.adaptWidth ? '7rem' : '10rem')};
  cursor: pointer;
  font-size: 0.8rem;
  position: relative;
  box-sizing: border-box;
  user-select: none;
  border-radius: 0.5rem;
  color: ${(props) => (props.active ? props.theme.colorOrange : props.theme.textColor)};
  font-weight: ${(props) => (props.active ? 'bold' : '400')};
  height: 2.5rem;
  border: ${(props) => (props.active ? '1px solid #ff9900' : '1px solid' + props.theme.colorGray)};
  transition: all 0.2s;
  opacity: ${(props) => (props.active ? '1' : '0.5')};
  z-index: 99999999999999;
  box-shadow: ${(props) => (!props.active ? 'none' : '0px -4px 20px rgba(0, 0, 0, 0.10)')};
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    color: #ff9900;
    border: 1px solid #ff9900;
    opacity: 1;
  }
`

export const TasksLogicTabContainer = styled.div`
  width: 100%;
  min-height: 500px;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  ${(props) => props.theme.container}
`

export const TaskLogicCanvas = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
  height: 100%;
  min-height: 0;
  position: relative;
  display: flex;
  flex-direction: column;
  ${(props) => props.theme.container};
  overflow: hidden;

  .react-flow {
    width: 100%;
    height: 100%;
    flex: 1;
  }

  .react-flow__background {
    background: ${(props) => props.theme.appBackground};
  }

  .react-flow__attribution {
    display: none;
  }

  .react-flow__edge-path {
    stroke-width: 2;
  }

  .react-flow__edge.selected .react-flow__edge-path {
    stroke-width: 3;
  }

  .react-flow__handle {
    width: 10px;
    height: 10px;
    background: #ff9900;
    border: 2px solid ${(props) => props.theme.appBackground};
  }

  .react-flow__handle-left {
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .react-flow__handle-right {
    left: auto;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
  }

  .react-flow__node {
    overflow: visible;
  }

  .react-flow__controls {
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
  }

  .react-flow__controls-button {
    background: ${(props) => props.theme.appBackground};
    border-bottom: 1px solid ${(props) => props.theme.thinSeparator};

    svg {
      fill: ${(props) => props.theme.textColor};
    }
  }

  .react-flow__controls-button:hover {
    background: ${(props) => props.theme.glassHover};
  }
`

export const TaskLogicToolbar = styled.div`
  position: absolute;
  top: 1rem;
  left: 1rem;
  z-index: 5;
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem;
  border-radius: 10px;
  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.12);
`

export const TaskLogicEmptyHint = styled.div<{ visible: boolean }>`
  position: absolute;
  inset: 0;
  display: ${(props) => (props.visible ? 'flex' : 'none')};
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) => props.theme.textColor};
  opacity: 0.55;
  font-size: 0.875rem;
  z-index: 1;
`

export const InputComponentNodeBox = styled.div<{ selected?: boolean }>`
  width: 160px;
  min-height: 56px;
  padding: 0.6rem 0.9rem;
  background: #ff9900;
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  color: #ffffff;
  font-size: 0.85rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  transition: box-shadow 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.selected &&
    css`
      box-shadow: 0px 6px 24px rgba(255, 153, 0, 0.45);
    `}

  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.2);
  }
`

export const CalcComponentNodeBox = styled.div<{ selected?: boolean; wired?: boolean }>`
  width: 160px;
  min-height: 56px;
  padding: 0.6rem 0.9rem;
  background: ${(props) => props.theme.appBackground};
  color: ${(props) => props.theme.textColor};
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  font-size: 0.85rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  border: 1px solid ${(props) => props.theme.thinSeparator};
  transition: box-shadow 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  ${(props) =>
    props.wired &&
    css`
      border-color: #ff9900;
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: 0px 6px 24px rgba(255, 153, 0, 0.35);
      border-color: #ff9900;
    `}

  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.18);
  }
`

export const FunctionNodeBox = styled.div<{ selected?: boolean; connected?: boolean }>`
  width: 220px;
  background: ${(props) => props.theme.appBackground};
  color: ${(props) => props.theme.textColor};
  border-radius: 12px;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid ${(props) => props.theme.thinSeparator};
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;

  ${(props) =>
    props.connected &&
    css`
      border-color: #ff9900;
    `}

  ${(props) =>
    props.selected &&
    css`
      box-shadow: 0px 6px 24px rgba(255, 153, 0, 0.35);
      border-color: #ff9900;
    `}

  &:hover {
    box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.18);
  }
`

export const FunctionNodeTitle = styled.div`
  padding: 0.6rem 0.9rem 0.5rem;
  font-size: 0.85rem;
  font-weight: 600;
  text-align: center;
  word-break: break-word;
  border-bottom: 1px solid ${(props) => props.theme.thinSeparator};
`

export const FunctionPortsRow = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.4rem 0;
`

export const FunctionPort = styled.div<{ side: 'left' | 'right' }>`
  position: relative;
  padding: 0.35rem 0.9rem;
  font-size: 0.72rem;
  color: ${(props) => props.theme.textColor};
  text-align: ${(props) => (props.side === 'left' ? 'left' : 'right')};
  overflow: visible;
`

export const FunctionPortLabel = styled.span`
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const FunctionPortGroupLabel = styled.div`
  font-size: 0.62rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${(props) => props.theme.textColor};
  opacity: 0.55;
  padding: 0 0.9rem;
  margin-top: 0.25rem;
`

export const TaskNodeDeleteBtn = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${(props) => props.theme.appBackground};
  border: 1px solid ${(props) => props.theme.thinSeparator};
  color: ${(props) => props.theme.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease, transform 0.15s ease;
  z-index: 2;

  svg {
    width: 12px;
    height: 12px;
  }

  &:hover {
    background: #ff5b5b;
    border-color: #ff5b5b;
    color: #fff;
    transform: scale(1.05);
  }

  &:hover svg path {
    stroke: #fff;
  }
`

export const TaskLogicEdgeDeleteButton = styled.button<{ show?: boolean }>`
  position: absolute;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: ${(props) => props.theme.appBackground};
  color: ${(props) => props.theme.textColor};
  border: 1.5px solid #ff9900;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: all;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.15);
  opacity: ${(props) => (props.show ? 1 : 0)};
  transition: opacity 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover {
    background: #ff9900;
    color: #fff;
  }
`
